var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMessaging = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5103",
    "data-name": "Group 5103",
    width: 34.687,
    height: 28.563,
    viewBox: "0 0 34.687 28.563",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19183",
    "data-name": "Path 19183",
    d: "M21.118,48.038a1.628,1.628,0,1,0,1.628,1.628A1.63,1.63,0,0,0,21.118,48.038Zm0,2.719a1.091,1.091,0,1,1,1.091-1.091A1.092,1.092,0,0,1,21.118,50.757Z",
    transform: "translate(-13.908 -34.512)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19184",
    "data-name": "Path 19184",
    d: "M56.182,48.038a1.628,1.628,0,1,0,1.628,1.628A1.63,1.63,0,0,0,56.182,48.038Zm0,2.719a1.091,1.091,0,1,1,1.091-1.091A1.092,1.092,0,0,1,56.182,50.757Z",
    transform: "translate(-35.466 -34.512)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19185",
    "data-name": "Path 19185",
    d: "M38.672,48.038A1.628,1.628,0,1,0,40.3,49.666,1.63,1.63,0,0,0,38.672,48.038Zm0,2.719a1.091,1.091,0,1,1,1.092-1.091A1.092,1.092,0,0,1,38.672,50.757Z",
    transform: "translate(-24.701 -34.512)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19186",
    "data-name": "Path 19186",
    d: "M37.093,12.923H14.339a2.6,2.6,0,0,0-2.594,2.595v4.121H7.594A2.6,2.6,0,0,0,5,22.233V34A2.6,2.6,0,0,0,7.594,36.6H9.143v4.439a.447.447,0,0,0,.752.327L15,36.6H30.349A2.6,2.6,0,0,0,32.943,34V29.883h4.15a2.6,2.6,0,0,0,2.594-2.594V15.518A2.6,2.6,0,0,0,37.093,12.923ZM30.349,35.7H14.824a.447.447,0,0,0-.305.121l-4.481,4.184V36.152A.448.448,0,0,0,9.59,35.7h-2a1.7,1.7,0,0,1-1.7-1.7V22.233a1.7,1.7,0,0,1,1.7-1.7H30.349a1.7,1.7,0,0,1,1.7,1.7V34A1.7,1.7,0,0,1,30.349,35.7Zm8.444-8.415a1.7,1.7,0,0,1-1.7,1.7h-4.15V22.233a2.6,2.6,0,0,0-2.594-2.594H12.639V15.518a1.7,1.7,0,0,1,1.7-1.7H37.094a1.7,1.7,0,0,1,1.7,1.7V27.289Z",
    transform: "translate(-5 -12.923)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessaging, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Messaging.984b2907.svg";
export { ForwardRef as ReactComponent };